import { IconAbacus, IconAdjustments, IconActivity } from '@tabler/icons-react';
import IconLitecoin from '../../../Icon/IconLitecoin';

function UserLevelCardComp({ carddata }) {
  const ProductivityOptions = {
    series: [{ data: carddata.card1[0].data }],
    options: {
      chart: { height: 45, type: 'line', sparkline: { enabled: true } },
      stroke: { width: 2 },
      markers: { size: 0 },
      colors: ['#EE1D23'], // Red Line
      grid: { padding: { top: 0, bottom: 0, left: 0 } },
      tooltip: { x: { show: false }, y: { title: { formatter: () => '' } } },
    },
  };

  return (
    <div className="pt-4">
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-6">
        {/* MTD Productivity Card - RED */}
        <div className="bg-white shadow-2xl rounded-xl p-6 border-4 border-[#EE1D23] transition-transform transform hover:scale-105 hover:shadow-3xl">
          <div className="flex items-center space-x-4 mb-4">
            <div className="w-14 h-14 flex items-center justify-center bg-[#EE1D23] text-white rounded-xl shadow-md">
              <IconAbacus size={30} />
            </div>
            <div>
              <h6 className="text-[#1A2B5C] font-semibold text-lg">MTD Productivity</h6>
              <p className="text-4xl font-bold text-[#1A2B5C]">{carddata.card1[0].MTDProduction}</p>
            </div>
          </div>
          {/* <p className="text-[#808080] text-sm mt-2">Last Month: <span className="text-[#1A2B5C] font-semibold">{carddata.card1[0].LastMonth}</span></p> */}
        </div>

        {/* PKT Percentage Card - BLUE */}
        <div className="bg-white shadow-2xl rounded-xl p-6 border-4 border-[#1A2B5C] transition-transform transform hover:scale-105 hover:shadow-3xl">
          <div className="flex items-center space-x-4 mb-4">
            <div className="w-14 h-14 flex items-center justify-center bg-[#1A2B5C] text-white rounded-xl shadow-md">
              <IconAdjustments size={30} />
            </div>
            <div>
              <h6 className="text-[#1A2B5C] font-semibold text-lg">PKT Percentage</h6>
              <p className="text-4xl font-bold text-[#1A2B5C]">{parseFloat(carddata.card2[0].MTDProduction).toFixed(2)}</p>
            </div>
          </div>
          <p className="text-[#808080] text-sm mt-2">Updated Data Available</p>
        </div>

        {/* Tool Effectiveness Card - GRAY */}
        <div className="bg-white shadow-2xl rounded-xl p-6 border-4 border-[#808080] transition-transform transform hover:scale-105 hover:shadow-3xl">
          <div className="flex items-center space-x-4 mb-4">
            <div className="w-14 h-14 flex items-center justify-center bg-[#808080] text-white rounded-xl shadow-md">
              <IconLitecoin size={30} />
            </div>
            <div>
              <h6 className="text-[#1A2B5C] font-semibold text-lg">Tool Effectiveness</h6>
              <p className="text-4xl font-bold text-[#1A2B5C]">{carddata.card3[0].MTDProduction}</p>
            </div>
          </div>
          <p className="text-[#808080] text-sm mt-2">Efficiency Metrics</p>
        </div>

        {/* Real-Time Production Count Card - RED */}
        <div className="bg-white shadow-2xl rounded-xl p-6 border-4 border-[#EE1D23] transition-transform transform hover:scale-105 hover:shadow-3xl">
          <div className="flex items-center space-x-4 mb-4">
            <div className="w-14 h-14 flex items-center justify-center bg-[#EE1D23] text-white rounded-xl shadow-md">
              <IconActivity size={30} />
            </div>
            <div>
              <h6 className="text-[#1A2B5C] font-semibold text-lg">Real-Time Production</h6>
              <p className="text-4xl font-bold text-[#1A2B5C]">{carddata.card4[0].MTDProduction}</p>
            </div>
          </div>
          <p className="text-[#808080] text-sm mt-2">Live Count Updates</p>
        </div>
      </div>
    </div>
  );
}

export default UserLevelCardComp;
